import kGameConfigJson from '../../config/koenigsburg/koenigsburg_config.json';
import kTileCountJson from '../../config/koenigsburg/koenigsburg_tilecount.json';
import kTilemapJson from '../../config/koenigsburg/koenigsburg_tilemap.json';
import { TileGameConfig } from '../tilebase/TileGameConfig';
import { KTileDef } from './KTileGameConfig';

/**
 * Load and parse ccson game config
 */

export type KTileGroup = 'koenigsburg_hexa' | 'koenigsburg_rhombus' | 'koenigsburg_triangle';

export type KGameTypeDTO = 'fixed' | 'koenigsburg';

const kTileMap: Record<number, KTileDef> = kTilemapJson as Record<number, KTileDef>;
export const gameConfigs = kGameConfigJson as TileGameConfig[];
export const tileMapConfig = kTileMap;

export function parseTileCount(tileCountJson: Record<string, string[]>) {
  const tileCount = new Map();
  Object.entries(tileCountJson).forEach(([key, value]) => {
    const tc = new Map();
    value.forEach((s) => {
      const parts = s.split(':');
      tc.set(parseInt(parts[0]), parseInt(parts[1]));
    });
    tileCount.set(key, tc);
  });
  return tileCount;
}
export const tileCountConfig = parseTileCount(kTileCountJson as Record<string, string[]>);
